import { render, staticRenderFns } from "./product-material-photo-preview.vue?vue&type=template&id=4ab00b21&scoped=true&"
import script from "./product-material-photo-preview.vue?vue&type=script&lang=js&"
export * from "./product-material-photo-preview.vue?vue&type=script&lang=js&"
import style0 from "./product-material-photo-preview.vue?vue&type=style&index=0&id=4ab00b21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab00b21",
  null
  
)

export default component.exports